(function() {
  'use strict';

  angular.module('component.accounts')
    .component('orgChooser', {
      templateUrl: 'app/components/accounts/org-chooser.html',
      controller: 'OrgChooserController',
      controllerAs: 'orgChooserCtrl'
    });
})();
